var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-layout"},[_c('el-aside',{staticClass:"nav-left",attrs:{"width":"200px"}},[_c('Steper',{attrs:{"data":_vm.modulers,"current":_vm.current}})],1),_c('Content',{staticClass:"c-create-scroll",staticStyle:{"position":"relative","overflow":"auto","-webkit-overflow-scrolling":"touch"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }